/** The `/wrapped` page: loads the recap and hands it to the story player. */

import { Unauthorized } from "../api/client";
import { Login } from "../app/Login";
import { NotOut, useWrapped } from "./api";
import { buildDeck } from "./player/deck";
import { Player } from "./player/Player";
import { RosterProvider } from "./story/stage";
import { FONT_BODY, FONT_DISPLAY, PAGE, PAPER } from "./theme";
import "./wrapped.css";

function Splash({ title, detail }: { title: string; detail?: string }) {
  return (
    <main
      className="flex min-h-dvh flex-col items-center justify-center gap-4 px-6 text-center"
      style={{ fontFamily: FONT_BODY, background: PAGE, color: PAPER }}
    >
      <h1 className="text-4xl font-extrabold leading-tight" style={{ fontFamily: FONT_DISPLAY, fontStretch: "75%" }}>
        {title}
      </h1>
      {detail ? <p className="max-w-sm opacity-70">{detail}</p> : null}
      <a href="/" className="rounded-full border border-current px-4 py-2 text-sm opacity-80">
        Back to the stats
      </a>
    </main>
  );
}

export function Wrapped() {
  // An admin previews someone else with ?person=<id>; the server checks it's an admin.
  const person = new URLSearchParams(window.location.search).get("person") ?? undefined;
  const query = useWrapped(person);

  if (query.error instanceof Unauthorized) return <Login />;
  if (query.error instanceof NotOut) {
    return <Splash title="Wrapped isn't out yet" detail="Check back soon." />;
  }
  if (query.error) return <Splash title="Wrapped didn't load" detail={query.error.message} />;
  if (!query.data) return <Splash title="Wrapping up your year…" />;
  const data = query.data;
  // Colours go to everyone in the recap in the ceremony's order, the same on every card.
  const roster = data.chat.ceremony.map((winner) => winner.name);
  return (
    <RosterProvider names={roster} avatars={data.avatars}>
      <Player deck={buildDeck(data)} title={data.period.title} music={data.music ?? null} />
    </RosterProvider>
  );
}
